import {Component, EventEmitter, Input, OnChanges, SimpleChanges, AfterViewInit, ViewChildren, QueryList, ElementRef, HostListener } from '@angular/core';
import {ListMessagesService} from "./services/list-messages.service";
import {SendMessageService} from "./services/send-message.service";
import {MessageDto} from "../../../auto-generated-server-dtos/claim/messages/message-dto";
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import {catchError, Subject} from "rxjs";

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements AfterViewInit, OnChanges {
  messages: MessageDto[] = [];
  @Input() claimDto: ClaimDto | null = null;
  @Input() isAdjusterView: boolean = false;
  @Input() refreshMessages?: Subject<void>;
  @Input() toName: string = 'Global Warranty';
  newMessage: string = '';
  newMessageInTransit: boolean = false;
  sendingErrorOccurred: boolean = false;
  @Input() statusUpdated!: EventEmitter<void>;
  messageExpanded: { [key: string]: boolean } = {};
  messageTruncated: boolean[] = [];
  @ViewChildren('messageContentItem') messageContentItems!: QueryList<ElementRef>;

  constructor(
    private listMessagesService: ListMessagesService,
    private sendMessageService: SendMessageService,
  )
  {
  }

  ngAfterViewInit() {
    this.messageContentItems.changes.subscribe(() => {
      this.checkMessageTruncation();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.claimDto && changes.claimDto.currentValue) {
      this.listMessages();
      this.refreshMessages?.subscribe(() => {
        this.listMessages();
      });
    }
    if(changes.statusUpdated) {
      this.statusUpdated.subscribe(() => {
        if(this.claimDto?.status === 'Approved' || this.claimDto?.status === 'Rejected') {
          this.sendMessage();
        }
      });
    }
  }

  private listMessages() {
    this.listMessagesService.listMessages(this.claimDto!.claimId).subscribe(messages => {
      this.messages = messages;
    });
  }

  sendMessage() {
    if (!this.newMessage) {
      return;
    }
    this.newMessageInTransit = true;
    this.sendingErrorOccurred = false;

    this.sendMessageService.sendMessage(this.newMessage, this.claimDto!.claimId)
      .pipe(
        catchError(err => {
          this.newMessageInTransit = false;
          this.sendingErrorOccurred = true;
          throw err;
        })
      )
      .subscribe(() => {
      this.listMessagesService.listMessages(this.claimDto!.claimId).pipe(
        catchError(err => {
          this.newMessageInTransit = false;
          this.sendingErrorOccurred = true;
          throw err;
        })
      ).subscribe(messages => {
        this.messages = messages;
        this.newMessage = '';
        this.newMessageInTransit = false;
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  protected onResize() {
    this.checkMessageTruncation();
  }

  protected checkMessageTruncation() {
    this.messageContentItems.forEach((item, index) => {
      this.messageTruncated[index] = (item.nativeElement.scrollHeight > item.nativeElement.clientHeight);
    });
  }

  protected isMessageTruncated(index: number): boolean {
    return this.messageTruncated[index];
  }

  protected showHideMessage(message: MessageDto): void {
    this.messageExpanded[message.createdDateTime.toString()] = !this.messageExpanded[message.createdDateTime.toString()];
  }

  protected isMessageExpanded(message: MessageDto): boolean {
    return this.messageExpanded[message.createdDateTime.toString()];
  }
  
}
